   

const schedules = [
     {
      id: 1,
       title: 'Arrival',
       time: "9:00am",
       description: `Red-carpet, Registration and Breakfast Reception`,
     },
     {
      id: 2,
       title: 'Commencement',
       time: "10:30 - 10:45 am  ",
       description: `TEDx Introductory Film, Opening Prayer and Welcome Address
`,
     },
     {
      id: 3,
       title: 'Talks Commencement',
       time: "10:45 - 11:25am",
       description: `First Set of Talks`,
     },
     {
      id: 4,
       title: 'APPRECIATION OF SPONSORS',
       time: "11:25 AM - 11:35 AM",
       description: `Recognition of Sponsors`,
     },
     {
      id: 5,
       title: 'TALKS PROCEED',
       time: "11: 35 AM- 12:15 PM ",
       description: `Second Set of Talks`,
     },
     {
      id: 6,
       title: 'INNOVATIVE SHOWCASE BY INTERSWITCH',
       time: "12:15 PM - 12:30PM",
       description: `Interswitch Presentation`,
     },
     {
      id: 7,
       title: 'CAPTIVATING CULMINATION',
       time: "12:30PM - 1:10 PM",
       description: `Final Set of TED Talks`,
     },
     {
      id: 8,
       title: 'SHORT BREAK',
       time: "1:10 PM - 1:25 PM",
       description: `Artistic Performance and Refreshment Break`,
     },
     {
      id: 9,
       title: 'ENGAGING EXCHANGE',
       time: "1:25 PM - 2:00 PM",
       description: `Interactive Panel Session`,
     },
     {
      id: 10,
       title: 'ENTERTAINMENT AND EXCITEMENT',
       time: "2:00 PM - 2:15 PM",
       description: `Games and Raffle Draws`,
     },
     {
      id: 11,
       title: 'HONORING EXCELLENCE',
       time: "2:15 PM - 2:30PM",
       description: `Recognition of Speakers and Bestowal of Awards`,
     },
     {
      id: 12,
       title: 'WRAP UP AND DEPARTURE',
       time: "",
       description: `Closing Address by the Organizer`,
     },
   ]

export default schedules